"use client";

import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";

import { Spinner } from "@/components/loader/spinner";
import FlightSearchForm from "@/feature/flight/search/components/form/flight-search-form";
import { refetch } from "@/feature/flight/search/state/slices/flight-search-status.slice";
import { useAppDispatch } from "@/redux/hooks";
import { parseAsStringLiteral, useQueryState } from "nuqs";

const TAB_IDS = ["flights", "hotels", "visa", "holidays"] as const;
const tabParser = parseAsStringLiteral(TAB_IDS).withDefault("flights");

const HotelSearchForm = dynamic(
  () => import("@/feature/hotel/search/components/form/hotel-search-form"),
  {
    loading: () => (
      <div className="flex min-h-26 items-center justify-center py-6">
        <Spinner size="md" />
      </div>
    ),
  },
);

const HolidaySearchForm = dynamic(
  () => import("@/feature/holiday/search/components/form/holiday-search-form"),
  {
    loading: () => (
      <div className="flex min-h-26 items-center justify-center py-6">
        <Spinner size="md" />
      </div>
    ),
  },
);

const VisaSearchForm = dynamic(
  () =>
    import("@/feature/visa/search/components/form/visa-search-form").then(
      (mod) => mod.VisaSearchForm,
    ),
  {
    loading: () => (
      <div className="flex min-h-26 items-center justify-center py-6">
        <Spinner size="md" />
      </div>
    ),
  },
);

export function SearchFormSwitcher() {
  const [tab] = useQueryState("tab", tabParser);
  const router = useRouter();
  const dispatch = useAppDispatch();

  if (tab === "hotels") {
    return <HotelSearchForm />;
  }

  if (tab === "visa") {
    return <VisaSearchForm />;
  }

  if (tab === "holidays") {
    return <HolidaySearchForm />;
  }

  return (
    <FlightSearchForm
      submitHandler={({ searchParams }) => {
        dispatch(refetch(true));
        router.push(`/flights${searchParams}`);
      }}
    />
  );
}
